import React from "react";
import { IconProps } from "../icon";

export const Hurricane_03Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M21 4H3m17 4H6m12 4H9m6 4H8m9 4h-5"
    />
  </svg>
);
